import { generatePath, Link } from "react-router-dom"
import { computed } from "mobx"
import { observer } from "mobx-react"
import { Button, List, Typography } from "antd"
import { SafetyOutlined } from "@ant-design/icons"
import classNames from "classnames"

import { authStore } from "@src/app/authStore"
import { DefaultPageLayout } from "@src/app/layouts/DefaultPageLayout"
import { MockData, mockData } from "@src/app/mocks/kycMock"
import { paths } from "@src/app/paths"
import UiStore from "@src/app/uiStore"
import uiStore from "@src/app/uiStore"
import { MerchantResponse } from "@src/shared/api/generated"
import css from "./index.module.css"

const { Paragraph, Title } = Typography

const { Item } = List

export const KybPage = observer(() => {
  const { isTransferioTheme } = uiStore()

  const data = computed(() => {
    return [
      {
        level: 0,
        limits: [
          "limit in crypto - $10 000",
          ...(isTransferioTheme ? [] : ["limit in fiat - $0"]),
        ],
      },
      {
        level: 1,
        limits: [
          "limit in crypto - it is unlimited",
          ...(isTransferioTheme ? [] : ["limit in fiat - $0"]),
        ],
      },
      {
        level: 2,
        limits: [
          "limit in crypto - it is unlimited",
          ...(isTransferioTheme
            ? []
            : ["limit in fiat - agreed upon individually"]),
        ],
      },
    ] as MockData[]
  }).get()

  return (
    <DefaultPageLayout title="KYB">
      <div className={css.cardsWrapper}>
        {data.map((item) => (
          <Card key={item.level} {...item} />
        ))}
      </div>
    </DefaultPageLayout>
  )
})

function Card({ level, limits }: MockData) {
  const { kyb_level } = authStore.merchant as MerchantResponse

  const isActive = level === kyb_level

  return (
    <div className={css.card}>
      <div
        className={classNames(css.iconWrapper, {
          [css.iconWrapperActive as string]: isActive,
        })}
      >
        <SafetyOutlined
          className={classNames(css.icon, {
            [css.iconActive as string]: isActive,
          })}
        />
      </div>
      <Paragraph className={css.description}>Level {level}</Paragraph>
      <Paragraph
        className={classNames(css.titleDescription, {
          [css.textActive as string]: isActive,
        })}
        style={{ textAlign: "center" }}
      >
        {level === 0 ? "KYB-free testing period" : "KYB is required"}
      </Paragraph>
      {isActive && (
        <>
          <Title level={4} style={{ marginBottom: "8px", marginTop: 0 }}>
            You are at this level.
          </Title>
          <Paragraph
            className={classNames(css.titleDescription, {
              [css.textActive as string]: isActive,
            })}
          >
            The currently available limits:
          </Paragraph>
        </>
      )}
      <Title level={4} style={{ marginBottom: 0, marginTop: 0 }}>
        {level === 0 ? "Total turnover:" : "Withdraw/payout:"}
      </Title>
      <List
        dataSource={limits}
        renderItem={(item) => (
          <Item
            className={classNames(css.listItem, {
              [css.listItemActive as string]: isActive,
            })}
          >
            <Typography.Text
              className={classNames(css.text, {
                [css.textActive as string]: isActive,
              })}
            >
              {item}
            </Typography.Text>
          </Item>
        )}
      />
      {!isActive && kyb_level! < level && (
        <Link
          id="GENERATED_ID_KYB_LINK_VOID_1"
          to={generatePath(paths.kybInner, { id: level.toString() })}
        >
          {!UiStore().isTransferioTheme && (
            <Button
              className={css.button}
              id="GENERATED_ID_KYB_BUTTON_GO_THROUGH_KYB_1"
              type="primary"
            >
              Go through KYB
            </Button>
          )}
        </Link>
      )}
    </div>
  )
}
